import React from "react";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import locale from "../../utils/locale";
import { toTitleCase } from "../../utils/textTransform";
import NotMe from "../NotMe";
import renderIf from "../../utils/renderIf";

import "./LandingPage.css";

const style = {
  background: "linear-gradient(45deg, #0A5DB8 30%, #0A5DB8 90%)",
  marginTop: "20px",
};

const LandingPage = ({
  owner,
  seller,
  year,
  model,
  make,
  color,
  onNotMeClick,
  onGetStartedClick,
  showNotMe,
  sellerType,
  sellerCompanyCode = "",
}) => (
  <div className="stepperContent">
    {renderIf(showNotMe)(
      <NotMe
        sellerCompany={seller}
        year={year}
        model={model}
        make={make}
        color={color}
        onNotMeClick={onNotMeClick}
        disable={false}
      />
    )}

    <div className="landing-page">
      {locale("landingPageText", owner, sellerType === "C", {
        sellerCompanyCode,
      })}
      <Button
        className="br-25"
        onClick={onGetStartedClick}
        variant="raised"
        color="primary"
        fullWidth
        style={style}
      >
        <strong>{locale("get_started")}</strong>
      </Button>
    </div>
  </div>
);

LandingPage.propTypes = {
  onGetStartedClick: PropTypes.func,
};

export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/LandingPage/index.js